import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef ,useCallback } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import MCQMultiSelect from "../../QuestionPage/MultiOptionSelect";

// Fetching Data from the API]

// End

// Page Html
export default function MCQMultipleAnswerMockPage({ question , onInputChange , questionNumber,maxQuestion  }) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAttempted, setIsAttempted] = useState(false);
  const [submitted, setSubmitted] = useState(false);


  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioLink(question.media_link);
    setOriginalWords(question.question);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
    resetAudio();
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleSelectedOptionsChange = useCallback((selected) => {
    console.log("Selected options:", selected);
    setSelectedOptions(selected);
    onInputChange(selected);

  }, []);

  useEffect(() => {
    console.log("selectedOptions state updated:", selectedOptions);
  }, [selectedOptions]);


  return (
    <div>
      <div className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
        <div className="h-1.5 rounded-full bg-violet-600"></div>
        <h3 className="pt-4 text-2xl font-extrabold text-gray-900 sm:text-3xl">
          Multiple Choice, Multiple Answers
        </h3>
        <h2 className="hidden">
          {" "}
        </h2>
        <h2 className="mt-3 inline-flex rounded-md bg-violet-50 px-3 py-2 text-sm font-bold text-violet-800 ring-1 ring-violet-100">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="mt-4 max-w-5xl text-sm leading-6 text-gray-600 sm:text-base">
          Listen to the audio and answer the multiple-choice question. Choose all correct answers.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <MCQMultiSelect question={Mcq_Question} options={McqOptions} onOptionSelect={handleSelectedOptionsChange}/>
      </div> 
    </div>
  );
}


